import axiosInstance from "./axiosInstance";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (param) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + "banner/list", {
    headers: authHeader(),
    params: param,
  });
};

const get = (id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `banner/view/${id}`,
    {
      headers: authHeader(),
    }
  );
};

const create = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + "banner/create",
    data,
    {
      headers: authHeader(),
    }
  );
};

const update = (id, data, param) => {
  return axiosInstance.Auth.put(
    process.env.REACT_APP_API_URL +
      `banner/update/${id}?currency=${param.currency}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const deleteBanner = (id, param) => {
  return axiosInstance.Auth.delete(
    process.env.REACT_APP_API_URL + `banner/delete/${id}`,
    {
      data: param,
      headers: authHeader(),
    }
  );
};

const restore = (id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `banner/restore/${id}`,
    {
      headers: authHeader(),
    }
  );
};
const uploadadImage = (formImage) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `banner/upload`,
    formImage,
    {
      headers: multipartHeader(),
    }
  );
};

const getOfferBannersList = (params) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `offerBanner/list?status=${params.status}`
  );
};

const createOfferBanner = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `offerBanner/create`,
    data,
    {
      headers: multipartHeader(),
    }
  );
};
const deleteOfferBanner = (id) => {
  return axiosInstance.Auth.delete(
    process.env.REACT_APP_API_URL + `offerBanner/delete/${id}`,
    {
      headers: authHeader(),
    }
  );
};

const getBannerInfo = (id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `banner/view/${id}`,
    {
      headers: authHeader(),
    }
  );
};

export default {
  getAll,
  get,
  create,
  update,
  deleteBanner,
  restore,
  uploadadImage,
  getOfferBannersList,
  createOfferBanner,
  deleteOfferBanner,
};
